const RELATION_OWNED_BY = "ownedBy";
const RELATION_OWNER_OF = "ownerOf";
const RELATION_CONSUMES_API = "consumesApi";
const RELATION_API_CONSUMED_BY = "apiConsumedBy";
const RELATION_PROVIDES_API = "providesApi";
const RELATION_API_PROVIDED_BY = "apiProvidedBy";
const RELATION_DEPENDS_ON = "dependsOn";
const RELATION_DEPENDENCY_OF = "dependencyOf";
const RELATION_PARENT_OF = "parentOf";
const RELATION_CHILD_OF = "childOf";
const RELATION_MEMBER_OF = "memberOf";
const RELATION_HAS_MEMBER = "hasMember";
const RELATION_PART_OF = "partOf";
const RELATION_HAS_PART = "hasPart";

export { RELATION_API_CONSUMED_BY, RELATION_API_PROVIDED_BY, RELATION_CHILD_OF, RELATION_CONSUMES_API, RELATION_DEPENDENCY_OF, RELATION_DEPENDS_ON, RELATION_HAS_MEMBER, RELATION_HAS_PART, RELATION_MEMBER_OF, RELATION_OWNED_BY, RELATION_OWNER_OF, RELATION_PARENT_OF, RELATION_PART_OF, RELATION_PROVIDES_API };
//# sourceMappingURL=relations.esm.js.map
